import { get } from 'svelte/store';
import { user } from '$lib/user';

export const getUser = () => {
	const currentUserStore = get(user);

	if (!currentUserStore) {
		throw new Error('No current logged in user');
	}

	return currentUserStore;
};
